window.CKEDITOR_BASEPATH = '/webpack/ckeditor/'

// Load your custom config.js file for CKEditor.
require(`!file-loader?context=${__dirname}&outputPath=../ckeditor/&name=[path][name].[ext]!./config.js`)

// Load your custom contents.css file in case you use iframe editor.
require(`!file-loader?context=${__dirname}&outputPath=../ckeditor/&name=[path][name].[ext]!./contents.css`)

// Load your custom styles.js file for CKEditor.
require(`!file-loader?context=${__dirname}&outputPath=../ckeditor/&name=[path][name].[ext]!./styles.js`)

// Load files from plugins.
require.context(
	`!file-loader?context=${__dirname}&outputPath=../ckeditor/&name=[path][name].[ext]!./plugins/`,
	true,
	/.*/
)

// Load CKEditor lang files.
require.context(
	`!file-loader?context=${__dirname}&outputPath=../ckeditor/&name=[path][name].[ext]!./lang/`,
	true,
	/.*/
)

// Load skin.
require.context(
	`!file-loader?context=${__dirname}&outputPath=../ckeditor/&name=[path][name].[ext]!./skins/moono-lisa`,
	true,
	/.*/
)

// NOTE: prevent problems by using import instead of require caused by window.CKEDITOR_BASEPATH not surviving until it's used.
require('./ckeditor')

// prevent error on secured clipboard memory -> use dialog if necessary
CKEDITOR.on('instanceReady', function(event) {
	event.editor.on('beforeCommandExec', function(event) {
		// Show the paste dialog for the paste buttons and right-click paste
		if (event.data.name === 'paste') {
			event.editor._.forcePasteDialog = true;
		}
		// Don't show the paste dialog for Ctrl+Shift+V
		if (event.data.name === 'pastetext' && event.data.commandData.from === 'keystrokeHandler') {
			event.cancel();
		}
	})
});
